"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var rule_constants_1 = require("./rule-constants");
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.static,
    value: false
};
/** Factory that generates Immutable [[IStaticCondition]] */
exports.StaticConditionRecord = immutable_1.Record(exports.defaultValues);
/** an immutable version of the [[IStaticCondition]] */
var ImmutableStaticCondition = /** @class */ (function (_super) {
    __extends(ImmutableStaticCondition, _super);
    function ImmutableStaticCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableStaticCondition;
}(exports.StaticConditionRecord));
exports.ImmutableStaticCondition = ImmutableStaticCondition;
//# sourceMappingURL=static-condition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/static-condition.js
// module id = 1119
// module chunks = 0